import { useEffect, useState } from 'react';
import { getTrackedEmails } from '../../lib/use-cases/get-tracked-emails';

function useTrackedEmails() {
    const [trackedEmailList, setTrackedEmailList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const getData = async () => {
        const list = await getTrackedEmails();

        setTrackedEmailList(list);
        setIsLoading(false);
    };

    useEffect(() => {
        getData();
    }, []);

    return {
        trackedEmailList,
        isLoading
    }
};

export {
    useTrackedEmails
};
